import { RecoilState, RecoilValueReadOnly, selectorFamily } from 'recoil';
import { VideoAssetBody, VideoAssetResponse } from '../../../API';
import { localAtom } from '../../../state/localStorageState';
import { AssetTypesEnum, INITIAL_ASSET_TYPE } from '../../../utils/assetTypes';
import { DataManagerState, DataManagerStateFullReturnType } from '../../DataManager';

export interface VideoAssetStateReturnType extends DataManagerStateFullReturnType<VideoAssetResponse, VideoAssetBody> {
  withAssetByFilePath: (param: string | undefined) => RecoilValueReadOnly<VideoAssetResponse | undefined>;
  withSelectedAssetType: RecoilState<AssetTypesEnum>;
}

export function VideoAssetsState(name: string): VideoAssetStateReturnType {
  const genericState = DataManagerState<VideoAssetResponse, VideoAssetBody>(name);

  const withAssetByFilePath = selectorFamily<VideoAssetResponse | undefined, string | undefined>({
    key: 'videoAssets.assetByFilePath',
    get: (filePath) => {
      return ({ get }) => {
        if (!filePath) return;
        const data = get(genericState.withDataCache);
        return Object.values(data).find((asset) => asset.object.filePath === filePath)?.object;
      };
    }
  });

  const withSelectedAssetType = localAtom<AssetTypesEnum>({
    key: 'videoAssets.selectedAssetType',
    default: INITIAL_ASSET_TYPE
  });

  return {
    ...genericState,
    withAssetByFilePath,
    withSelectedAssetType
  };
}
